// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.step-viewer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(11, 45, 113, 0.32);
  backdrop-filter: blur(8px) saturate(1.1);
  -webkit-backdrop-filter: blur(8px) saturate(1.1);
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px;
  animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.viewer-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  animation: cardIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes cardIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 22px;
  background: #0B2D71;
  color: #fff;
  flex-shrink: 0;
  position: relative;
}
.card-header .step-title {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  max-width: 46%;
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-header .header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.card-header .header-left .tutorial-name {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-header .header-left .step-chip {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 4px 11px;
  border-radius: 20px;
  line-height: 1;
}
.card-header .header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.card-header .icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  transition: background 0.2s ease;
}
.card-header .icon-btn:hover {
  background: rgba(255, 255, 255, 0.24);
}
.card-header .link-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: 20px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.card-header .link-btn i {
  font-size: 12px;
}
.card-header .link-btn:hover {
  background: rgba(255, 255, 255, 0.24);
}

.progress-segments {
  display: flex;
  gap: 4px;
  padding: 12px 22px 0;
  flex-shrink: 0;
}
.progress-segments .segment {
  flex: 1;
  height: 5px;
  border: none;
  padding: 0;
  border-radius: 3px;
  background: #EFEFEF;
  cursor: pointer;
  transition: background 0.25s ease;
}
.progress-segments .segment.completed {
  background: #009DD9;
}
.progress-segments .segment.active {
  background: #0066B2;
}
.progress-segments .segment:hover:not(.active) {
  background: rgb(213.5, 213.5, 213.5);
}
.progress-segments .segment.completed:hover {
  background: rgb(0, 134.8608294931, 186.4);
}

.card-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 18px 26px 22px;
  display: flex;
  flex-direction: column;
  text-align: center;
}
.card-body .step-instruction {
  margin: 0 auto 18px;
  max-width: 100%;
  width: 100%;
  text-align: left;
  font-size: 15px;
  line-height: 1.35;
  color: #3a3a3a;
  flex-shrink: 0;
  overflow-wrap: break-word;
  word-break: break-word;
}
.card-body .step-instruction ::ng-deep p {
  margin: 0;
}
.card-body .step-instruction ::ng-deep p:last-child {
  margin-bottom: 0;
}
.card-body .step-instruction ::ng-deep ul, .card-body .step-instruction ::ng-deep ol {
  margin: 0 0 8px;
  padding-left: 22px;
  text-align: left;
}
.card-body .step-instruction ::ng-deep a {
  color: #0066B2;
}
.card-body .step-instruction ::ng-deep .ql-align-center {
  text-align: center;
}
.card-body .step-instruction ::ng-deep .ql-align-right {
  text-align: right;
}
.card-body .step-instruction ::ng-deep .ql-align-justify {
  text-align: justify;
}
.card-body .step-instruction ::ng-deep code {
  background: #EFEFEF;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: monospace;
  font-size: 13px;
}
.card-body .stage {
  flex: 1 1 auto;
  min-height: 0;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}
.card-body .side-nav {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.card-body .side-nav i {
  font-size: 12px;
}
.card-body .side-nav.prev {
  background: #fff;
  border: 1px solid darkgray;
  color: #3a3a3a;
}
.card-body .side-nav.prev:hover:not(:disabled) {
  background: #EFEFEF;
}
.card-body .side-nav.prev:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.card-body .side-nav.next {
  background: #0066B2;
  border: 1px solid #0066B2;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 102, 178, 0.3);
}
.card-body .side-nav.next:hover {
  background: rgb(0, 84.4651685393, 147.4);
  border-color: rgb(0, 84.4651685393, 147.4);
}
.card-body .media {
  flex: 0 1 auto;
  align-self: stretch;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 0;
  overflow: hidden;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: none;
}
.card-body .media.media--empty {
  background: transparent;
  border: none;
  box-shadow: none;
}
.card-body .media .step-image {
  display: block;
  max-width: 100%;
  max-height: 72vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border: 3px ridge rgba(180, 188, 198, 0.65);
  border-radius: 10px;
  background: transparent;
}

@media (max-width: 768px) {
  .card-header {
    padding: 12px 14px;
  }
  .card-header .header-left {
    gap: 8px;
  }
  .card-header .header-left .tutorial-name {
    font-size: 15px;
  }
  .card-body {
    padding: 14px 16px 18px;
  }
  .stage {
    gap: 8px;
  }
  .side-nav {
    padding: 10px 12px;
    font-size: 13px;
  }
  .side-nav span {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .step-viewer-overlay,
  .viewer-card {
    animation: none;
  }
  .segment,
  .icon-btn,
  .side-nav,
  .link-btn {
    transition: none;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
